
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[username]/[nonprofitSlug]/[shortId]",
      function () {
        return require("private-next-pages/user/[username]/[nonprofitSlug]/[shortId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[username]/[nonprofitSlug]/[shortId]"])
      });
    }
  